import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GmiApi } from "../gmi.api";
import { EstablishmentExpectedProducts } from "./models/establishment-expected-products.model";
import { ExpectedProductsDto } from "./dto/expected-products.dto";

export class EstablishmentExpectedProductsApi extends GmiApi {
    constructor(http: HttpClient, id: number) {
        super(`establishment/${id}/expected-product`, http);
    }

    public getAllFromEstablishmentId(): Observable<EstablishmentExpectedProducts[]> {
        return this.get<EstablishmentExpectedProducts[]>("");
    }

    public update(productId: number, dto: ExpectedProductsDto): Observable<EstablishmentExpectedProducts> {
        return this.put<EstablishmentExpectedProducts>(`${productId}`, dto);
    }
}
